import { colors } from "./colors";
import { fonts } from "./fonts";
const mobSize = 360;
const borderSizes = {
  basic: 2
};
const containerGaps = {
  mob: 16,
  mobLg: 24,
  tablet: 32,
  sm: 32,
  md: 48,
  lg: 52
};
const theme = {
  colors,
  fonts,
  opacities: {
    op100: 100,
    op80: 80,
    op64: 64,
    op52: 52,
    op40: 40,
    op32: 32,
    op24: 24,
    op16: 16,
    op12: 12,
    op8: 8,
    op4: 4,
    op09: 0.9
  },
  spacings: {
    xs5: 2,
    xs4: 4,
    xs3: 8,
    xs2: 12,
    xs: 16,
    sm: 24,
    md: 32,
    lg: 40,
    xl: 52,
    xl2: 64,
    xl3: 80,
    xl4: 96
  },
  transitions: {
    basic: '200ms ease',
    fast: '125ms ease-in-out'
  },
  icon_sizes: {
    xs: '8',
    sm: '16',
    md: '24',
    lg: '32',
    xl: '52'
  },
  inputControl_paddings: {
    xl: 18,
    lg: 16,
    md: 12,
    mobile: 14
  },
  border_sizes: borderSizes,
  borders: {
    basic: `${borderSizes.basic}px solid`
  },
  scrollbar_width: 19,
  radiuses: {
    xl: 10,
    lg: 8,
    md: 6,
    sm: 4,
    xs: 2,
    round: 5000
  },
  breakpoints: {
    none: 0,
    mob: 360,
    mobLg: 600,
    tablet: 768,
    xs: 960,
    sm: 1024,
    md: 1280,
    lg: 1440,
    uber: 1920
  },
  layout: {
    lg: {
      width: 1292,
      padding: 32
    },
    md: {
      width: 1152,
      padding: 32
    },
    sm: {
      width: 880,
      padding: 32
    },
    tablet: {
      width: 672,
      padding: 32
    },
    mobLg: {
      width: 568,
      padding: 24
    },
    mob: {
      width: 288,
      padding: 16
    }
  },
  z_indexes: {
    zero: 0,
    high: 99999,
    negative: -1,
    basic: 1,
    med: 5000
  },
  container_gaps: containerGaps,
  min_width: mobSize - containerGaps.mob * 2,
  sizes: {
    lesser: {
      xl: 40,
      lg: 32,
      md: 24,
      sm: 20,
      xs: 16
    },
    greater: {
      xl: 72,
      lg: 52,
      md: 44,
      sm: 32
    }
  },
  shadows: {
    cardDefault: '0px 2px 4px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.08)',
    cardHover: '0px 9px 10px rgba(0, 0, 0, 0.08), 0px 0px 8px rgba(0, 0, 0, 0.08)',
    cardActive: '0px 0px 8px rgba(0, 0, 0, 0.08), 0px 6px 12px rgba(0, 0, 0, 0.08)',
    dropdown: '0px 20px 30px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.12)',
    modal: '0px 40px 44px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.08)',
    buttonDefault: '0px 0px 8px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.1)',
    buttonHoverFocus: '0px 0px 8px rgba(0, 0, 0, 0.08), 0px 9px 10px rgba(0, 0, 0, 0.08)',
    buttonActive: '0px 6px 12px rgba(0, 0, 0, 0.08), 0px 0px 8px rgba(0, 0, 0, 0.08)'
  }
};
export { theme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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